import React, { useEffect } from 'react'

import * as COMMONFUNCTIONS from '../../utils/CommonFunctions'

import Top from '../common/top';
import Header from '../common/header';
import Footer from '../common/footer';

import { Link } from "react-router-dom";

function PUMFailure()
{
    useEffect(() => {
        COMMONFUNCTIONS.moveToTop();

        COMMONFUNCTIONS.commonMessageErrorToast('Payment Failed !');
    })
    return (
        <div>
            <Top/>
            <Header/>
            {/* REGISTER */}
            <section>
                <div class="login pg-soon">
                    <div class="container">
                        <div class="row">
                            <div class="inn">
                                <div class="counter">
                                    <div class="timer p-b-20">
                                        <span class="days"><i class="fa fa-times-circle font-50" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                                <div class="tit p-b-20">
                                    <h4 className='p-b-10'>Payment Failed</h4>
                                    <h1>Ooops !</h1>
                                </div>
                                <div class="menu-pop-soci p-b-20">
                                    <h5>Something went wrong. Please try again later.</h5>
                                    <h5>For any queries <Link to="/contact.html" style={{textDecoration : 'underline'}} className='black-text'>Contact Our Agents</Link>.</h5>
                                </div>
                                <div>
                                    <Link class="btn btn-outline-primary" to="/plans.html">Go To Plans</Link>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <div className='clear'></div> */}
            {/* END */}
            <Footer/>
        </div>
    )
}

export default PUMFailure